<template>
  <section>
    <v-layout row style="width: 90%;margin: auto;">
      <v-data-table :headers="headers"
                    :items="GetProjects"
                    item-key="Project_Title"
                    class="elevation-1"
                    style="width:100%;margin-top:10px;">
        <template v-slot:headers="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text">
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-center">{{ props.item.Project_Title }}</td>
            <td class="text-xs-center">
              <section style="height: 56px;width: 320px;white-space: pre-line;overflow: hidden;text-overflow: ellipsis;" v-html="props.item.Project_Description"></section>
            </td>
            <td>
              <video :id="'video_table_'+props.item._id" loop controls :src="props.item.Project_Video" style="width: 200px;height: 100px;padding: 10px;"></video>
            </td>
            <td class="text-xs-center">{{ props.item.Enable }}</td>
            <td class="text-xs-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" icon class="btnAction" @click="OpenUpdateProjectModal(props.item)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </template>
                <span>Update Description</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" icon class="btnAction" @click="OpenUpdateProjectDescription(props.item)">
                    <v-icon>description</v-icon>
                  </v-btn>
                </template>
                <span>Update Curriculam</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" icon class="btnAction" @click="OpenUpdateProjectVideoModal(props.item)">
                    <v-icon>attach_file</v-icon>
                  </v-btn>
                </template>
                <span>Update Files</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn color="error" icon class="btnAction" @click="DeleteMiniProject(props.item)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </template>
                <span>Delete Files</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-layout>
    <app-mini-projects ref="miniprojects" :dialog="UpdateAddProject" @close="CloseDialog"></app-mini-projects>
    <app-project-curriculam
      ref="projectcurriculam"
      :dialog="UpdateAddProjectDescription"
      @close="CloseDialog"
    ></app-project-curriculam>
    <app-video-or-zip ref="videoorzip" :dialog="UpdateAddProjectVideo" @close="CloseDialog"></app-video-or-zip>
  </section>
</template>

<script>
import appMiniProjects from "../dialogs/AddMiniProjects";
import appProjectCurriculam from "../dialogs/AddMiniProjectCurriculam";
import appVideoOrZip from "../dialogs/AddVideoORZip";

export default {
  components: {
    appMiniProjects,
    appProjectCurriculam,
    appVideoOrZip
  },
  data() {
    return {
      headers: [
        { text: "Project Title", value: "Project_Title" },
        { text: "Project Description", value: "Project_Description" },
        { text: "Project Video", value: "Project_Video" },
        { text: "Active", value: "Enable" },
        { text: "Update Actions" }
      ],
      UpdateAddProject: false,
      UpdateAddProjectDescription: false,
      UpdateAddProjectVideo: false
    };
  },
  computed: {
    GetProjects() {
      return this.$store.getters.GetProjects;
    }
  },
  methods: {
    OpenUpdateProjectModal(Projects) {
      this.UpdateAddProject = true;
      this.$refs.miniprojects.GetDetailstoUpdate(Projects);
    },
    OpenUpdateProjectDescription(Projects) {
      this.UpdateAddProjectDescription = true;
      this.$refs.projectcurriculam.GetDetailstoUpdate(Projects);
    },
    OpenUpdateProjectVideoModal(Projects) {
      this.UpdateAddProjectVideo = true;
      this.$refs.videoorzip.GetDetailstoUpdate(Projects);
    },
    CloseDialog() {
      this.UpdateAddProject = false;
      this.UpdateAddProjectDescription = false;
      this.UpdateAddProjectVideo = false;
    },
    DeleteMiniProject(project){

      if (confirm("Do you really want to delete?")) {

          let data = { "Project_Id" :project['_id']}
          this.$http.post(`${this.$store.getters.GetProductionUrl}/miniproject/deleteminiproject`,data)
              .then(response => {
                  this.$store.commit("DeleteIndividualProjects", response["data"]["response"]);
              })
              .catch(err => {
                  this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error While Deleting Data", Color: "red", Close: false });
              });
        }
    }
  },
  mounted() {
  
    this.$http.post(`${this.$store.getters.GetProductionUrl}/miniproject/getminiprojects`,{})
          .then(response => {
              this.$store.commit("SetProjects", response["data"]["response"]);
          })
          .catch(err => {
              this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error While Fetching Data", Color: "red", Close: false });
          });
  }
};
</script>
<style scoped>
/* .clsForActions {
  margin: 2px;
  padding: 2px;
  border: 1px solid #0000003d;
  border-radius: 2px;
} */
</style>


